import { Logo, Timer } from '../../components';
import lightModeLogo from '../../assets/logos/lightModeLogo.png';
import darkModeLogo from '../../assets/logos/darkModeLogo.png';
import styles from './RuntimePage.module.scss';
import { THEME } from '../../constants';
import PropTypes from 'prop-types';

function RuntimePage(props) {
  const { theme } = props;

  document.onclick = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };
  return (
    <div className={styles.scannerContainer}>
      <div className={styles.logo}>
        <Logo image={theme === THEME.LIGHT ? lightModeLogo : darkModeLogo} />
      </div>
      <div className={styles.timer}>
        <Timer />
      </div>
    </div>
  );
}
export default RuntimePage;
RuntimePage.propTypes = {
  theme: PropTypes.string,
};
